import type { ICredReqEventUser } from '$shared/interfaces/api/ICredReqEventUser';

export default class CredReqEventUser {
  public id: string;
  public email: string;

  constructor(response: ICredReqEventUser) {
    if (!response) {
      return;
    }
    this.id = response.id;
    this.email = response.email;
  }
}
